import { cn } from '@/lib/cn';

export interface BetslipTotalsProps {
  maxOdds: string;
  possibleWin: string;
  /** Extra win from an applied attractive combi tier. Omitted when none applies. */
  combiBonus?: string;
  className?: string;
}

/** Figma BetslipTotals — max. odds, optional combi bonus, and possible win. */
export function BetslipTotals({ maxOdds, possibleWin, combiBonus, className }: BetslipTotalsProps) {
  return (
    <dl className={cn('flex w-full flex-col gap-1 text-[13px]', className)}>
      <div className="flex h-[18px] items-center justify-between gap-2">
        <dt className="text-text-secondary">max. odds</dt>
        <dd className="font-bold tabular-nums text-text-primary">{maxOdds}</dd>
      </div>
      {combiBonus ? (
        <div className="flex h-[18px] items-center justify-between gap-2">
          <dt className="text-text-secondary">combi bonus</dt>
          <dd className="font-bold tabular-nums text-status-warning">{combiBonus}</dd>
        </div>
      ) : null}
      <div className="flex h-[18px] items-center justify-between gap-2">
        <dt className="text-text-secondary">possible win</dt>
        <dd className="font-bold tabular-nums text-text-primary">{possibleWin}</dd>
      </div>
    </dl>
  );
}
